module.exports = __webpack_public_path__ + "img/77.8c511485.png";